// extracted by mini-css-extract-plugin
module.exports = {"tooltipTrigger":"tooltip_tooltipTrigger__qtCWH","tooltip":"tooltip_tooltip__jHG7v","arrow":"tooltip_arrow__1mt_J"};